/* eslint no-undef: 0 */
import dynamic from 'next/dynamic';
import { Button, Glyphicon } from 'reaxl';

const VideoPlayer = dynamic(() => import('./VideoPlayer.js'), { ssr: false });

function GenericVideoPlayer({
    video,
    ctaOptions,
    autostart,
    originPage,
}) {
    const {
        destinationUrl,
        ctaText,
        ctaOnMediaEvent,
        ctaOnClick,
    } = ctaOptions;

    const ctaOnClickListener = (event) => {
        if (typeof window.jwplayer === 'function') {
            const playerInstance = window.jwplayer(`v${video.id}`);
            if (playerInstance && playerInstance.pause && playerInstance.getState() === 'playing') {
                playerInstance.pause();
            }
        }

        if (typeof ctaOnClick === 'function') {
            ctaOnClick(event);
        }
    };

    return (
        <div className="VideoContainer">
            <VideoPlayer
                originPage={originPage}
                video={video}
                autostart={autostart}
                onPlayCallBack={ctaOnMediaEvent}
                onPauseCallBack={originPage !== 'dhs' && ctaOnMediaEvent}
                onCompletedCallBack={ctaOnMediaEvent}
                onReplayCallBack={originPage !== 'dhs' && ctaOnMediaEvent}
                onMilestonesCallBack={originPage !== 'dhs' && ctaOnMediaEvent}
            />
            {ctaText && destinationUrl && (
                <Button
                    data-cmp="test"
                    className="video-cta"
                    block
                    bsSize="small"
                    bsStyle="default"
                    rel="nofollow noopener"
                    target="_blank"
                    href={destinationUrl}
                    onClick={ctaOnClickListener}
                >
                    {ctaText}
                    <Glyphicon
                        glyph="offsite"
                        className="margin-left-2"
                    />
                </Button>
            )}
        </div>
    );
}

GenericVideoPlayer.displayName = 'GenericVideoPlayer';

export default GenericVideoPlayer;
